"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const SvgCertDefaultHoriz = props => (0, jsx_runtime_1.jsx)("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 89.75,
  height: 32.965
}, props, {
  children: (0, jsx_runtime_1.jsxs)("g", Object.assign({
    "data-name": "Group 907"
  }, {
    children: [(0, jsx_runtime_1.jsx)("text", Object.assign({
      transform: "translate(36.75 24.679)",
      fontSize: 20,
      fontFamily: "Roboto-Bold, Roboto",
      fontWeight: 700
    }, {
      children: (0, jsx_runtime_1.jsx)("tspan", Object.assign({
        x: 0,
        y: 0
      }, {
        children: 'CERT.'
      }), void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("g", Object.assign({
      "data-name": "Group 837"
    }, {
      children: (0, jsx_runtime_1.jsxs)("g", Object.assign({
        "data-name": "Group 836",
        transform: "translate(-496.265 -6022.405)",
        fill: "#fff",
        strokeWidth: 1.5
      }, {
        children: [(0, jsx_runtime_1.jsxs)("g", Object.assign({
          "data-name": "Group 835",
          stroke: "#2d5dec"
        }, {
          children: [(0, jsx_runtime_1.jsx)("path", {
            "data-name": "Path 546",
            d: "M518.03 6053.01l-2.249-.226a.447.447 0 00-.358.125l-1.618 1.579a.448.448 0 01-.736-.172l-4.974-14.217 5.427-1.9 4.974 14.217a.448.448 0 01-.466.594z"
          }, void 0), (0, jsx_runtime_1.jsx)("path", {
            "data-name": "Path 547",
            d: "M500.992 6053.01l2.249-.226a.447.447 0 01.358.125l1.617 1.579a.448.448 0 00.736-.172l4.974-14.217-5.428-1.9-4.975 14.217a.448.448 0 00.469.594z"
          }, void 0)]
        }), void 0), (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 548",
          d: "M511.229 6024.045h0a2.1 2.1 0 002.6.7h0a2.1 2.1 0 012.974 1.717h0a2.1 2.1 0 001.9 1.9h0a2.1 2.1 0 011.717 2.973h0a2.1 2.1 0 00.7 2.6h0a2.1 2.1 0 010 3.434h0a2.1 2.1 0 00-.7 2.6h0a2.1 2.1 0 01-1.717 2.974h0a2.1 2.1 0 00-1.9 1.9h0a2.1 2.1 0 01-2.974 1.717h0a2.1 2.1 0 00-2.6.7h0a2.1 2.1 0 01-3.434 0h0a2.1 2.1 0 00-2.6-.7h0a2.1 2.1 0 01-2.974-1.717h0a2.1 2.1 0 00-1.9-1.9h0a2.1 2.1 0 01-1.717-2.974h0a2.1 2.1 0 00-.7-2.6h0a2.1 2.1 0 010-3.434h0a2.1 2.1 0 00.7-2.6h0a2.1 2.1 0 011.717-2.973h0a2.1 2.1 0 001.9-1.9h0a2.1 2.1 0 012.974-1.717h0a2.1 2.1 0 002.6-.7h0a2.1 2.1 0 013.434 0z",
          stroke: "#fff"
        }, void 0), (0, jsx_runtime_1.jsx)("path", {
          "data-name": "Path 549",
          d: "M511.115 6024.81h0a1.962 1.962 0 002.428.65h0a1.961 1.961 0 012.778 1.6h0a1.962 1.962 0 001.778 1.777h0a1.962 1.962 0 011.6 2.778h0a1.962 1.962 0 00.651 2.428h0a1.962 1.962 0 010 3.208h0a1.962 1.962 0 00-.651 2.428h0a1.962 1.962 0 01-1.6 2.778h0a1.962 1.962 0 00-1.778 1.777h0a1.961 1.961 0 01-2.778 1.6h0a1.962 1.962 0 00-2.428.65h0a1.961 1.961 0 01-3.208 0h0a1.962 1.962 0 00-2.428-.65h0a1.961 1.961 0 01-2.778-1.6h0a1.961 1.961 0 00-1.778-1.777h0a1.962 1.962 0 01-1.6-2.778h0a1.962 1.962 0 00-.651-2.428h0a1.962 1.962 0 010-3.208h0a1.962 1.962 0 00.651-2.428h0a1.962 1.962 0 011.6-2.778h0a1.961 1.961 0 001.778-1.777h0a1.961 1.961 0 012.778-1.6h0a1.962 1.962 0 002.428-.65h0a1.962 1.962 0 013.208 0z",
          stroke: "#2d5dec"
        }, void 0), (0, jsx_runtime_1.jsx)("circle", {
          "data-name": "Ellipse 28",
          cx: 6.934,
          cy: 6.934,
          r: 6.934,
          transform: "translate(502.578 6028.718)",
          stroke: "#2d5dec"
        }, void 0)]
      }), void 0)
    }), void 0)]
  }), void 0)
}), void 0);

exports.default = SvgCertDefaultHoriz;